import { AxiosInstance } from 'axios';
import { ApiService } from '../model/Api.model';

enum BCheckRetryServiceEnum {
  handleRetry = "/retry"
}

export class BCheckRetryService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/contingency/bcheck");
  }
  public handleRetry = async (tradeId: number): Promise<any[]> => await this.POST(BCheckRetryServiceEnum.handleRetry, {tradeId});

}



// WEBPACK FOOTER //
// ./src/services/api/BCheckRetry.service.ts